import React, { useState } from 'react';

/**
 * "This already happens elsewhere": shown when switching something on would
 * send clients a second message for the same thing. Keep both on the left,
 * switching the other one off on the right.
 */
export default function ClashCard({ title, text, offLabel, onKeep, onSwitchOff, onDismiss }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const off = async () => {
    setBusy(true); setError('');
    try { await onSwitchOff(); } catch (e) { setError((e && e.message) || 'That didn’t save. Try again.'); setBusy(false); }
  };
  return (
    <div className="sp-confirm-overlay" style={{ zIndex: 100030 }} onClick={(e) => { if (e.target === e.currentTarget && !busy) (onDismiss || onKeep)(); }}>
      <div className="sp-confirm-card" role="alertdialog" aria-modal="true" aria-label={title}>
        <div className="sp-confirm-icon sp-confirm-icon--warning" aria-hidden="true">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 9v4M12 17h.01" /><path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" /></svg>
        </div>
        <h3 className="sp-confirm-title">{title}</h3>
        <p className="sp-confirm-text">{text}</p>
        {error && <p className="sp-confirm-text" style={{ color: '#B42318' }} role="alert">{error}</p>}
        <div className="sp-confirm-actions">
          <button type="button" className="sp-btn-secondary" disabled={busy} onClick={onKeep}>Keep both</button>
          <button type="button" className="sp-btn-primary" disabled={busy} onClick={off}>{busy ? 'Switching off…' : offLabel}</button>
        </div>
      </div>
    </div>
  );
}
